module.exports = __webpack_public_path__ + "static/media/pic5.727a542e.png";